import getErrorStartDate from './validations/startDate'
import { dateToString, alterDate } from '@hc-frontend/utils'

function setStartDate(value) {
  const tomorrow = alterDate({ days: 1 })
  return getErrorStartDate(value) ? dateToString(tomorrow) : value
}

export default setStartDate
